<template>
    <div class="v-radio" :class="{'checked': isSelected}">
        <input type="radio" v-bind="{ id, name, disabled, required, value, checked: isSelected }">

        <label :for="id" v-if="$slots.default" @click.prevent="toggleCheck">
            <slot/>
        </label>
    </div>
</template>

<script>
    import { v4 as uuidv4 } from "uuid";

    export default {
        name: "v-radio",
        props: {
            value: {
                type: [String, Number, Boolean, Object]
            },
            model: {
                type: [String, Number, Boolean, Object]
            },
            required: {
                type: Boolean
            },
            disabled: {
                type: Boolean
            },
            name: {
                type: [String, Number]
            }
        },
        model: {
            prop: "model",
            event: "change"
        },
        computed: {
            isSelected () {
                return this.model === this.value;
            }
        },
        data () {
            return {
                id: uuidv4()
            };
        },
        methods: {
            toggleCheck () {
                if (!this.disabled) {
                    this.$emit("change", this.value);
                }
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>
